import React from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';

const slides = [
  {
    title: 'Khalanga Global Ventures',
    subtitle: 'Smart logistics powering Africa’s supply chains.',
    cta: 'Explore Logistics',
    bgClass: 'bg-hero-logistics',
  },
  {
    title: 'Infrastructure & Civil Engineering',
    subtitle: 'Building resilient, future-ready infrastructure.',
    cta: 'View Infrastructure',
    bgClass: 'bg-hero-infrastructure',
  },
  {
    title: 'Construction Excellence',
    subtitle: 'Delivering world-class construction projects.',
    cta: 'Our Construction Services',
    bgClass: 'bg-hero-construction',
  },
  {
    title: 'Sustainability & Governance',
    subtitle: 'Building responsibly for future generations.',
    cta: 'Our ESG Approach',
    bgClass: 'bg-hero-esg',
  },
];

const Hero = () => {
  return (
    <section className="relative h-screen">
      <Swiper
        modules={[Autoplay, EffectFade, Pagination]}
        effect="fade"
        loop
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        className="h-full"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
              className={`relative h-screen bg-center bg-cover flex items-center justify-center ${slide.bgClass}`}
            >
              {/* Dark overlay */}
              <div className="absolute inset-0 bg-black/60" />

              <motion.div
                className="relative z-10 p-12 rounded-xl text-center max-w-4xl mx-4"
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: 'easeOut' }}
              >
                <h1 className="text-5xl md:text-6xl font-bold text-gold mb-6">
                  {slide.title}
                </h1>

                <p className="text-white text-lg md:text-xl mb-8">
                  {slide.subtitle}
                </p>

                <a
                  href="#services"
                  className="inline-block bg-gold text-black font-semibold px-8 py-4 rounded-full hover:bg-yellow-400 transition-all duration-300 shadow-lg"
                >
                  {slide.cta}
                </a>
              </motion.div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Hero;
